import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import cn from 'classnames';

import { useCommunityMembership } from '../../_hooks/useCommunityMembership';
import { usePostComposer } from '../PostComposer';
import { ComposerTrigger } from './ComposerTrigger';
import { composerFloatingShadowClass, composerPillWidthClass } from './composerStyles';
import { StickyComposerFooter } from './StickyComposerFooter';

type PostInputProps = { spaceSlug?: string } & (
  | { placement: 'inline' }
  | { placement?: 'sticky'; isVisible?: boolean }
);

export const PostInput: FC<PostInputProps> = (props) => {
  const { spaceSlug } = props;
  const placement = props.placement ?? 'sticky';
  const isVisible = props.placement === 'inline' ? true : (props.isVisible ?? true);

  const { t } = useTranslation();
  const { openComposer } = usePostComposer();
  const { currentMember } = useCommunityMembership();

  const avatarUrl = currentMember?.subscription?.avatar_url ?? undefined;
  const avatarName = currentMember?.subscription
    ? `${currentMember.subscription.first_name} ${currentMember.subscription.last_name}`.trim()
    : '';

  const triggerProps = {
    avatarUrl,
    avatarAlt: avatarName,
    placeholder: t('community.composer.join_conversation'),
    buttonLabel: t('community.composer.submit'),
    onClick: () => openComposer({ defaultSpaceSlug: spaceSlug }),
    ariaLabel: t('community.feed.create_post'),
  };

  if (placement === 'inline') {
    return (
      <div className="w-full py-4">
        <ComposerTrigger
          {...triggerProps}
          appearance="feed"
          className={cn(composerPillWidthClass, 'pointer-events-auto')}
        />
      </div>
    );
  }

  return (
    <StickyComposerFooter isVisible={isVisible}>
      <ComposerTrigger
        {...triggerProps}
        appearance="feed"
        disabled={!isVisible}
        className={cn(
          composerPillWidthClass,
          composerFloatingShadowClass,
          isVisible ? 'pointer-events-auto' : 'pointer-events-none',
        )}
      />
    </StickyComposerFooter>
  );
};
